// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"96":"7337379f","201":"ab61f880","734":"d7294dd5","795":"d1c753d4","943":"cc9e5da9"}[chunkId] + ".css";
};